<p>info-bar works!</p>
